/* @flow */

import type { Point, Tools } from './Common';
import { ParticleHoseWidth } from './Common';
import GlobalManager from './GlobalManager';
import Goal from './Goal';
import Ramp from './Ramp';
import Particle from './Particle';

export default class ParticleHose {
  goals: Array<Goal>;
  ramps: Array<Ramp>;
  origin: Point;
  color: string;
  particles = [];
  ticks = 0;
  width = ParticleHoseWidth;

  constructor(goals: Array<Goal>, ramps: Array<Ramp>, origin: Point, color: string) {
    GlobalManager.canvas.subscribeParticle(tools => this.draw(tools));
    GlobalManager.clock.subscribeParticle(() => this.step());
    this.goals = goals;
    this.ramps = ramps;
    this.origin = origin;
    this.color = color;
  }

  newParticleOrigin() {
    const stretch = this.width / 2;
    return {
      x: this.origin.x + stretch - Math.floor(stretch * 2 * Math.random()),
      y: this.origin.y + stretch - Math.floor(stretch * 2 * Math.random()),
    };
  }

  draw(tools: Tools) {
    const { particles } = this;
    tools.ctx.strokeStyle = this.color;
    particles.forEach(function(p) {
      if (!p.dead) {
        p.draw(tools);
      }
    });
  }

  spawnParticle(p: Particle) {
    p.spawn(this.newParticleOrigin(), this.color);
  }
  spawnGroup() {
    const { particles } = this;
    const groupSize = 20;
    let remainingToSpawn = groupSize;
    for (var pi = 0; pi < particles.length && remainingToSpawn > 0; pi++) {
      const p = particles[pi];
      if (p.dead) {
        this.spawnParticle(p);
        remainingToSpawn -= 1;
      }
    }
    for (; remainingToSpawn > 0; remainingToSpawn--) {
      const p = new Particle();
      this.spawnParticle(p);
      particles.push(p);
    }
  }
  step() {
    this.ticks += 1;
    if (this.ticks % 5 === 0) {
      this.spawnGroup();
    }
    const { particles, goals, ramps } = this;
    particles.forEach(function(p) {
      if (!p.dead) {
        p.step(goals, ramps);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/ParticleHose.js